import React from 'react'
import './Advantage_of_Loan.css'
import Advantage_Card from './Advantage_Card/Advantage_Card'

const Advantage_of_Loan = () => {
    return (
        <section className='Advantage_of_Loan'>
            <div className='conatiner_fluid p-0'>
                <div className='bg_img_holder'>
                    {/* <img src="\assets\Image\Home\Advantage\bg_img.png" className='bg_img' /> */}


                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className='main_info_div'>
                                    <p className='title'>
                                        Advantages of getting <br /> Loan or Insurance from  <br /> Profcyma
                                    </p>

                                    <p className='subtext'>
                                        We simplify your financial journey by offering personalized loan and insurance solutions tailored to your specific needs. Benefit from competitive rates & flexible terms, maximizing your financial advantages.
                                    </p>

                                    <p className='footer_text1'>
                                        Live Your Best Life Today,
                                    </p>

                                    <p className='fotter_text2'>
                                        Your Tomorrow Is Secured <span className='inner_text'>With Us!</span>
                                    </p>

                                </div>
                            </div>

                            <div className='col-lg-6 col-md-12 col-sm-12 col-sm-12'>

                                <div className='rigth_side_div'>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-6 col-sm-6 custom_col'>
                                            <div className='card_col_1'>
                                                <div className='card_conatiner_1'>
                                                    <Advantage_Card number="01" title="STREAMLINED PROCESSES" descn="Experience swift approvals and hassle-free transactions, ensuring efficiency in obtaining loans and insurance through Profcyma." />
                                                </div>

                                                <div className='card_conatiner_2'>
                                                    <Advantage_Card number="03" title="PERSONALIZED GUIDANCE" descn="Enjoy personalized financial guidance from our experts, tailor-ing loan and insurance options to match your unique needs and aspirations." />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-lg-6 col-md-6 col-sm-6 custom_col'>
                                            <div className='card_col_2'>
                                                <div className='card_conatiner_3'>
                                                    <Advantage_Card number="02" title="COMPETITIVE RATES" descn="Benefit from our industry-leading rates, ensuring that you receive the most cost-effective loan & insurance solutions available in the market." />

                                                </div>

                                                <div className='card_conatiner_4'>
                                                    <Advantage_Card number="04" title="CUTTING-EDGE TECHNOLOGY" descn="Harness the power of advanced technology for a seamless and user-friendly experience in managing and accessing your loan and insurance details." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='center_container'>
                                        <div className='img_holder'>
                                            <img src='/assets/Image/Home/Advantage/rupee.png' className='ruppe_img' />
                                        </div>
                                    </div>


                                </div>



                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default Advantage_of_Loan
